


































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import DocumentMixin from '@/mixins/DocumentMixin';
import EventMixin from '@/mixins/EventMixin';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import moment from 'moment';

@Component({
  components: {
    ConfirmDialog
  }
})
export default class QuoteDetail extends Mixins(
  DetailMixin,
  DocumentMixin,
  EventMixin
) {
  public tableCfg = FieldDefs;
  public url = this.getTableCfg(this.tableCfg, 'url');
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public version = 1;
  public treeVersion = 1;
  public templateDialogValue = false;
  public mailTemplate: any = {
    subject: '',
    body: ''
  };

  public get isNew() {
    return this.$route.params.id === 'new';
  }

  public showSendBillet() {
    // if (!this.roleCheckAPI('sale', 'sendaccounting')) {
    //   return false;
    // }
    const docType = this.getBookDocType(this.$route.path);
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      const is_invoice_or_creditnote = docType === 'sale_invoices' || docType === 'sale_credit_notes';
      console.log('showSendBillet', is_invoice_or_creditnote, layout.rec.sent_billit);
      if (!is_invoice_or_creditnote || layout.rec.sent_billit) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  public async sendBillit(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/sendbillit');
    const layout: any = this.$refs.layout;
    if (layout) {
      await layout.getRecord();
    }
  }



  public updateFields(rec) {
    if (rec.is_architect) {
      rec.lines.forEach(l => {
        l.original_unit_price = l.unit_price;
        l.estimated_quantity = l.quantity;
      });
    }
  }

  public async projectChanged(rec) {
    if (rec.project_id) {
      const projectResponse: any = await this.api.getRecord(
        null,
        '/projects/' + rec.project_id
      );
      if (projectResponse) {
        const project = projectResponse.data;
        rec.global_vatrate_id = project.global_vatrate_id;
        rec.customer_id = project.businessrelation_id;
        this.version += 1;
        this.setVatRateIds(rec);
      }
    }
  }

  public setVatRateIds(rec) {
    rec.lines.forEach(l => (l.vatrate_id = rec.global_vatrate_id));
    const ref: any = this.$refs.tree;
    ref.calculateTotalAmounts();
  }

  public customSave(rec, apiUrl) {
    const ref: any = this.$refs.layout;

    // Validate lines
    const valid = this.validateLines(rec);

    if (valid) {
      // Reset new lines with negative ID to 0
      rec.lines.forEach(l => (l.id = l.id < 0 ? 0 : l.id));
      // Only save lines of quotes with valid quantity (not zero)
      if (this.orderDocTypeNames[rec.orderdoctype_id] === 'quotes') {
        rec.lines = rec.lines.filter(l => l.quantity > 0);
      }
      ref.commitRecord(rec);
      (this.$refs.tree as any).initialize();
    } else {
      ref.loading = false;
    }
  }

  public getObject(transition, rec) {
    const object = {
      orderdoctype_id: transition.orderDocTypeId,
      linkeddoc_id: rec.id
    };
    if (transition.object) {
      // Evaluate the value of every key of the object
      // You can use all root fields of the record
      for (const key of Object.keys(transition.object)) {
        const value = transition.object[key];
        const params: string[] = value.match(/{([^}]*)}/g);
        if (params) {
          for (const param of params) {
            // Remove brackets
            const paramValue = param.substring(1, param.length - 1);
            const regExp = new RegExp(param);
            object[key] = value.replace(regExp, rec[paramValue]);
          }
        } else {
          object[key] = value;
        }
      }
    }
    return object;
  }

  public async getEmailTemplate(rec) {
    const response = await this.api.postAction(
      null,
      this.getTableCfg(this.tableCfg, 'apiUrl') +
        String(rec.id) +
        '/getmailtemplate'
    );
    if (response) {
      this.mailTemplate = response.data;
    }
    this.templateDialogValue = true;
  }

  public async openLinkedItem(linkedDocId) {
    const response = await this.api.getRecord(
      null,
      this.getTableCfg(this.tableCfg, 'apiUrl') + String(linkedDocId)
    );
    if (response) {
      const item = response.data;
      this.openDocumentForItem(item);
    }
  }

  public async sendEmail(rec) {
    const response = await this.api.postAction(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/sendmail',
      this.mailTemplate
    );
  }

  public async executeAction(rec, postAction) {
    const ref: any = this.$refs.layout;
    const response = await this.api.postAction(
      this.$store,
      this.getTableCfg(this.tableCfg, 'apiUrl') +
        String(rec.id) +
        '/' +
        postAction
    );
    if (response) {
      ref.getRecord();
    }
  }

  public async downloadDetail(apiUrl, id) {
    this.api.downloadAction(
      this.$store,
      apiUrl + String(id) + '/download_detail'
    );
  }

  public async updatePrices() {
    const ref: any = this.$refs.layout;
    ref.loading = true;
    // Get updated prices
    const response = await this.api.postAction(
      null,
      this.getTableCfg(this.tableCfg, 'apiUrl') +
        String(ref.rec.id) +
        '/updated_prices'
    );
    if (response) {
      // Update lines
      const data: any = response.data;
      for (const item of data) {
        const line: any = ref.rec.lines.find(v => v.id === item.orderline_id);
        if (line) {
          line.original_unit_price = item.unit_price;
          this.originalUnitPriceChanged(line);
        }
      }
      // Update tree component fields + initialize
      this.treeVersion += 1;
      const lineTable = (this.$refs.tree as any).$refs.table;
      if (lineTable) {
        lineTable.unitPriceVersion += 1;
      }
      (this.$refs.tree as any).initialize();
      ref.loading = false;
    }
  }

  public async initChoiceList(optionListName, endpoint) {
    const data = await this.api.getChoices(
      this.$store,
      '/' + optionListName + '/' + endpoint + '/'
    );
    if (data) {
      if (data.records.length > 0) {
        data.timestamp = Date.now();
        // Update cache
        this.setCachedChoice({
          name: optionListName + '-' + endpoint,
          value: data
        });
      }
    }
  }

  public created() {
    this.initChoiceList('products', 'choice_code');
    this.initChoiceList('unittypes', 'choice');
    this.initChoiceList('vatrates', 'choice');
  }

  public mounted() {
    const ref: any = this.$refs.layout;
    // Set vat rate if project_id is provided via url
    this.projectChanged(ref.rec);
    if (this.isNew) {
      if (this.isQuote()) {
        // expiration date quote - default 7 weeks
        ref.rec.due_date = moment()
          .add(4, 'weeks')
          .format('YYYY-MM-DD');
      }
      if (this.isInvoice()) {
        // expiration date invoice - default 15 days
        ref.rec.due_date = moment()
          .add(15, 'days')
          .format('YYYY-MM-DD');
      }
      ref.rec.creationdate = moment().format('YYYY-MM-DD');
    }
  }
}
